import levenshtein from 'js-levenshtein';

const TENANT_MAPPING = [
  {
    "id": "目黑1F-01",
    "name": "中日新聞東京本社"
  },
  {
    "id": "目黑2F-01",
    "name": "有限会社佐藤"
  },
  {
    "id": "目黑3F-01",
    "name": "株式会社アシスト"
  },
  {
    "id": "目黑4F-03",
    "name": "株式会社イー・ピー・シー"
  },
  {
    "id": "目黑5F-01",
    "name": "株式会社インフォコーパス"
  },
  {
    "id": "目黑6F-02",
    "name": "株式会社サンロクゴ"
  },
  {
    "id": "目黑7F-01",
    "name": "辛 永翔"
  },
  {
    "id": "茅場町1F-01",
    "name": "日暮勝秋"
  },
  {
    "id": "茅場町2F-01",
    "name": "（株）フィナンシャルクリエーション"
  },
  {
    "id": "茅場町3F-01",
    "name": "ファーイーストネットワーク（株）"
  },
  {
    "id": "茅場町4F-01",
    "name": "住友電設（株）"
  },
  {
    "id": "茅場町5F-01",
    "name": "ユニオンコンサルタント（株）"
  },
  {
    "id": "茅場町6F-01",
    "name": "オカベ株式会社"
  },
  {
    "id": "大井町1F-02",
    "name": "株式会社JIN DIN ROU"
  },
  {
    "id": "大井町2F-02",
    "name": "株式会社プラスビル"
  },
  {
    "id": "大井町2F-03",
    "name": "株式会社ダイニングイノベーション"
  },
  {
    "id": "大井町3F-02",
    "name": "大友美清"
  },
  {
    "id": "大井町4F-01",
    "name": "いちごハウス株式会社"
  },
  {
    "id": "大井町5F-01",
    "name": "いちごハウス株式会社"
  },
  {
    "id": "三軒茶屋201-01",
    "name": "三井住友海上火災保険株式会社"
  },
  {
    "id": "三軒茶屋202-02",
    "name": "バハ ナオミジェニファー"
  },
  {
    "id": "三軒茶屋301-01",
    "name": "カラバージョ イダルゴ フランク エリアス"
  },
  {
    "id": "三軒茶屋302-01",
    "name": "みずほ証券株式会社"
  },
  {
    "id": "三軒茶屋401-01",
    "name": "大西 敦之"
  },
  {
    "id": "三軒茶屋402-01",
    "name": "田口 梨沙"
  },
  {
    "id": "三軒茶屋501-02",
    "name": "山本　和美"
  },
  {
    "id": "三軒茶屋502-01",
    "name": "石塚 省一"
  },
  {
    "id": "三軒茶屋601-02",
    "name": "後藤　凪乃"
  },
  {
    "id": "三軒茶屋602-01",
    "name": "佐野 文洋"
  },
  {
    "id": "三軒茶屋701-01",
    "name": "正市園　美咲"
  },
  {
    "id": "三軒茶屋701-02",
    "name": "東山 泰成"
  },
  {
    "id": "三軒茶屋702-01",
    "name": "小野寺 斗弥"
  },
  {
    "id": "三軒茶屋801-01",
    "name": "阿南 由起子"
  },
  {
    "id": "三軒茶屋802-01",
    "name": "十九浦 彩香"
  },
  {
    "id": "三軒茶屋901-02",
    "name": "森本 真帆"
  },
  {
    "id": "三軒茶屋902-01",
    "name": "ロジャース ラングデン"
  },
  {
    "id": "三軒茶屋202-01",
    "name": "今 千亜紀"
  },
  {
    "id": "三軒茶屋901-01",
    "name": "小此木 結衣"
  }
];

const fullWidthToAsciiMap = {
  '０': '0', '１': '1', '２': '2', '３': '3', '４': '4',
  '５': '5', '６': '6', '７': '7', '８': '8', '９': '9'
};

function convertNonAsciiNumbers(text: string) {
  for (const [fullWidth, ascii] of Object.entries(fullWidthToAsciiMap)) {
    text = text.replaceAll(fullWidth, ascii);
  }
  return text;
}

// Remove special characters
function cleanName(n: string): string {
  return convertNonAsciiNumbers(n)
    .replaceAll('㈱', '')
    .replaceAll("（", "(")
    .replaceAll("）", ")")
    .replaceAll('(株)', '')
    .replace(/\s+/g, '')
    // Sometimes a partial month tenant will have things like "(6月分)"
    // in the name. Remove those.
    .replace(/\(([0-9]+月分)\)/g, '');
}

export function getTenantIdByName(n: string): string {
  let bestId: string | null = null;
  let bestScore: number = Infinity;
  for (const { id, name } of TENANT_MAPPING) {
    const a = cleanName(name);
    const b = cleanName(n);
    const diff = levenshtein(a, b);
    const score = diff / Math.max(a.length, b.length);

    if (score < bestScore) {
      bestId = id;
      bestScore = score;
    }
  }

  if (bestId == null || bestScore > 0.3) {
    throw new Error(`Tenant ${n} does not have id`);
  }
  return bestId;
}
